import type { DropAnimation } from '@dnd-kit/dom';

/** Design handoff: the tile settles into place — or snaps back — over 150ms ease-out. */
const DROP_DURATION_MS = 150;

/**
 * Drop animation for the tile drag overlay.
 *
 * Returns `null` under reduced motion, which tells dnd-kit to skip the animation entirely and let the
 * tile snap. The CSS half of the reduced-motion story cannot cover this: `dropAnimation` is a JS prop,
 * and the overlay is portalled outside the board's scoped media query.
 *
 * Timing only — the two visual effects that go with a drop live elsewhere: unwinding the lift is CSS
 * keyed off the `data-dnd-dropping` attribute dnd-kit puts on the overlay (see
 * `board-tile.module.scss`), and hiding the landed tile under the in-flight overlay is each
 * draggable's own `isDropping` (see `DraggableBoardTile`).
 */
export function tileDropAnimation(reducedMotion: boolean): DropAnimation | null {
  if (reducedMotion) return null;

  return { duration: DROP_DURATION_MS, easing: 'ease-out' };
}
